var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('apexchart',{key:_vm.chartComponentKey,attrs:{"type":"bar","height":280,"weight":230,"options":_vm.chartPowerOptions,"series":_vm.chartTransactions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }